module.exports = __webpack_public_path__ + "static/img/jianzhu11.b091d9d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/Content/Friend/jianzhu11.png
// module id = h35b
// module chunks = 12